import { defineMessages } from "react-intl";

export const messages = defineMessages({
  loadingMessage: {
    id: "rovo-extension.menu-page.loading-message",
    defaultMessage: "Loading...",
    description: "Message displayed when the menu page is loading.",
  },
  menuHeadingMessage: {
    id: "rovo-extension.menu-page.menu-heading-message",
    defaultMessage: "What's new in Rovo",
    description: "Message displayed on heading of menu page.",
  },
  menuSubheadingMessage: {
    id: "rovo-extension.menu-page.menu-subheading-message",
    defaultMessage: "Discover the latest updates and new features in Rovo",
    description: "Message displayed on subheading of menu page.",
  },
  allCategoryLabel: {
    id: "rovo-extension.menu-page.all-category-label",
    defaultMessage: "All",
    description:
      "The text is shown as a category filter tab or sidebar item in the menu page that, when selected, displays all available features across every category.",
  },
  aiSearchCategoryLabel: {
    id: "rovo-extension.menu-page.ai-search-category-label",
    defaultMessage: "AI Search",
    description:
      "The text is shown as a category filter tab or sidebar item in the menu page that, when selected, filters the feature list to show only AI Search-related features.",
  },
  chatCategoryLabel: {
    id: "rovo-extension.menu-page.chat-category-label",
    defaultMessage: "Chat",
    description:
      "The text is shown as a category filter tab or sidebar item in the menu page that, when selected, filters the feature list to show only Chat-related features.",
  },
  agentStudioCategoryLabel: {
    id: "rovo-extension.menu-page.agent-studio-category-label",
    defaultMessage: "Agent Studio",
    description: "Label displayed for Agent Studio category",
  },
  extensionCategoryLabel: {
    id: "rovo-extension.menu-page.extension-category-label",
    defaultMessage: "Extension",
    description:
      "The text is shown as a category filter tab or sidebar item in the menu page that, when selected, filters the feature list to show only browser extension-specific features.",
  },
  announcementAriaLabel: {
    id: "rovo-extension.menu-page.announcements.aria-label",
    defaultMessage: "Announcement: {title}",
    description: "Aria label for announcement on menu page. Title will be replaced with the actual announcement title.",
  },
});
